import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider } from '@mantine/core';
import { livlleeTheme } from './theme/theme';
import { ModalsProvider } from '@mantine/modals';
import { Notifications } from '@mantine/notifications';
import { setRetryLogger } from './services/api/baseApi';
import { logger } from './utils/logger';
import { queryClient } from './lib/queryClient';
import '@mantine/core/styles.css';

// TanStack Query: wrap app so useQuery/useMutation work everywhere. Enables request deduplication,
// caching, and single source of truth for server state (current user, trips, health) without duplicate fetches in Strict Mode.

// Wire retry logger so axios-retry logs in dev (ARCHITECTURE §1 + §3)
setRetryLogger({ debug: logger.debug });
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import App from './App.tsx';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    {/* TanStack Query: required so AuthContext, TripList, TripForm, Navbar can use useQuery/useMutation. */}
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={livlleeTheme} forceColorScheme="dark">
        <ModalsProvider>
          <Notifications />
          <App />
        </ModalsProvider>
      </MantineProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
